import React, { useEffect, useState } from 'react'
import { Button, Card } from 'react-bootstrap';
import Payment from './Payment';
import { deepCopy } from '../../Components/Shared/Utility/DeepCopy';
import { PaymentType } from './PaymentType';
import { PaymentTypeSelector } from './PaymentTypeSelector';
import { CreditCardClientLibrary, getCreditCardProcessor } from './PaymentProcessor';

interface IPaymentContainerProps {
    onPaymentChanged: (payment: Payment) => void;
    onPaymentTypeChanged: () => void;
    payment: Payment,
    disabled?: boolean
}

export const PaymentContainer = React.forwardRef((props: IPaymentContainerProps, ref: React.Ref<any>) => {
    const ccPaymentRef = React.useRef(null);
    const achPaymentRef = React.useRef(null);
    const [paymentButtonType, setPaymentButtonType] = useState<number>(0);

    const [creditCardProcessor, setCreditCardProcessor] = useState<CreditCardClientLibrary>(CreditCardClientLibrary.None);

    React.useImperativeHandle(ref,
        () => ({
            validate(payment: Payment) : boolean {
                var isValid = true;

                if (ccPaymentRef.current && !ccPaymentRef.current.validate(payment)) {
                    isValid = false;
                }

                if (achPaymentRef.current && !achPaymentRef.current.validate(payment)) {
                    isValid = false;
                }

                return isValid;
            }
        }),
    );

    const updatePaymentType = (paymentType: PaymentType, type: number) => {
        const updated = deepCopy(props.payment);
        updated.paymentType = paymentType;
        setPaymentButtonType(type);
        props.onPaymentChanged(updated);
        props.onPaymentTypeChanged();
    }

    useEffect(() => {
        if (creditCardProcessor !== CreditCardClientLibrary.None) return;
        
        const getCreditCardProcessorForPaymentContainer = async () => {
            const cardProcessor : CreditCardClientLibrary = await getCreditCardProcessor();
            setCreditCardProcessor(cardProcessor);
        }

        getCreditCardProcessorForPaymentContainer();

    }, [])

    return (
        <React.Fragment>
            <div>
                <Card.Text className="font-weight-bolder mb-1 pp-font-size-smaller mt-3">
                    Select Payment Method<span className="text-pp-primary ml-2">*</span>
                </Card.Text>
                <Button variant={paymentButtonType === 1 ? "pp-primary" : "outline-pp-primary"} disabled={props.disabled} onClick={() => updatePaymentType(PaymentType.CreditCardVisa, 1)}>Credit Card</Button>
                <Button variant={paymentButtonType === 2 ? "pp-primary" : "outline-pp-primary"} className="ml-2 mr-2" disabled={props.disabled} onClick={() => updatePaymentType(PaymentType.CreditCardVisa, 2)}>Debit Card (No Fee)</Button>
            </div>
            <PaymentTypeSelector ref={achPaymentRef} creditCardProcessor={creditCardProcessor} isDisabled={props.disabled} payment={props.payment} onPaymentChanged={props.onPaymentChanged}/>
        </React.Fragment>
    );
});